// ** React Imports
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'

// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'

// ** Toast & ThemeColors Context
import { ToastContainer } from 'react-toastify'
import { ThemeContext } from './utility/context/ThemeColors'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'
import { I18nextProvider} from "react-i18next"
import i18next from "i18next"
import global_es from './translations/es/global.json'
import global_en from './translations/en/global.json'
import { QueryClientProvider } from 'react-query'
import { createQueryClient } from './shared/config/queryClient'

const queryClient = createQueryClient()

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

const language = localStorage.getItem('LANGUAGE') !== null ? localStorage.getItem('LANGUAGE') : "es"


i18next.init({
    interpolation: {escapeValue: false},
    lng: language,
    fallbackLng: 'es',
    resources: {
        es: {
            global: global_es
        },
        en: {
            global: global_en
        }
    }

})

ReactDOM.render(
  <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Spinner/>}>
          <ThemeContext>
            <I18nextProvider i18n={i18next}>
              <LazyApp />
            <ToastContainer newestOnTop />
            </I18nextProvider>
          </ThemeContext>
        </Suspense>
      </QueryClientProvider>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
